export default __webpack_public_path__ + "static/media/learose-1440w.187a96f4.webp";